module.exports = __webpack_public_path__ + "static/media/loading.4df96d60.gif";